export default "__VITE_ASSET__sw5KcqeE__"